import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconExportTokens({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M8 .889A7.111 7.111 0 1 1 8 15.11 7.111 7.111 0 0 1 8 .889zm0 .889a6.222 6.222 0 1 0 0 12.444A6.222 6.222 0 0 0 8 1.778zM8 3.11a4.889 4.889 0 1 1 0 9.778A4.889 4.889 0 0 1 8 3.11zM8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm.147.889c.214-.003.39.196.386.441v.446c.189.039.383.112.578.228.198.103.28.374.18.594-.1.22-.341.3-.53.176-.596-.353-.963-.098-1.076.12-.057.107-.064.192-.016.296.048.104.183.258.518.361.463.141.804.43.972.808.169.38.145.826-.033 1.174a1.3 1.3 0 0 1-.593.582v.541c.01.248-.163.455-.38.455s-.39-.207-.38-.455v-.407a2.132 2.132 0 0 1-.887-.287c-.193-.103-.275-.369-.18-.587.095-.218.329-.305.518-.192.742.422 1.128.147 1.246-.085a.376.376 0 0 0 .012-.343c-.053-.119-.182-.27-.492-.366-.473-.145-.82-.42-.994-.793a1.331 1.331 0 0 1 .035-1.15c.157-.3.42-.524.742-.632V5.33c-.003-.24.164-.437.374-.441z"/>
        </svg>
    );
}

export default IconExportTokens;
